import { connect } from 'react-redux';
import AdminLoginPage from 'pages/AdminLoginPage';
import AdminActions from 'store/adminPanel/actions';

const mapStateToProps = state => {
  return {
    adminInfo: state.adminPanel.adminInfo,
    isLoginRequesting: state.adminPanel.isRequesting,
  };
};
const mapDispatchToProps = {
  adminLogin: AdminActions.Creators.adminLoginRequest,
};
export default connect(mapStateToProps, mapDispatchToProps)(AdminLoginPage);
